var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFubo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 184.787287,
    viewBox: "0 0 21.595468 7.408828",
    width: 541.162769,
    id: "svg2",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    transform: "translate(65.849967 -287.87186)",
    id: "g2"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m104.17752 2.4944887-2.33611 9.4000533-2.942945.030361 2.245155-9.3999707-3.367678.0608039.697792-2.5857362 12.772736.03036019.72818 8.09197761 4.30812-8.09197761h3.15526l-6.94762 11.86418181-2.66983.030361-1.66865-11.55991289.338 2.09905489z",
    fill: "#a6aaab",
    transform: "matrix(.17859375 0 0 .17859375 -65.717676 288.00417)",
    id: "path1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m-65.685161 291.00886.260092-1.27132.726058.0163c.220327-1.3836 1.134222-1.91422 2.692918-1.70598l-.238398 1.2659-.58518-.0109c-.289623.0111-.444499.16984-.48766.45094l.758573-.005-.238413 1.25501-.774825.0109-.78566 4.00954-1.36002.005.774825-4.02586zm3.571824-1.31493h1.430452l-.547258 2.82515c-.108369.59764-.222155 1.26045.487661 1.38542.196976.0284.399479.00026.591122-.0897.577745-.27145.718415-.84581.835225-1.42227l.545939-2.69313 1.370835-.005-1.05116 5.29718-1.257059.0163.05419-.26079c-.836068.55272-1.852751.47876-2.459382.0771-.58917-.41651-.723476-1.146-.575752-2.06956zm4.127805 5.31417 1.343762-.005.08128-.4292c.825376.89465 2.712788.59946 3.370223.0109-.362191-.37216-.515729-.81402-.574344-1.28762-.467805.61214-1.385323.68638-1.85851.32055-.444301-.31672-.559485-.94785-.44388-1.49481.104419-.49403.427945-.93144.900557-1.1216.559272-.225 1.229807-.0811 1.558954.35628.554102.90378.108631 1.65573.496156 2.46524.230646.48182.685766.89095 1.169784 1.10003.582538.25165 1.294182.30004 1.952857.10802.773561-.2255 1.409431-.78368 1.760202-1.50768.417244-.86105.446576-1.92399.0087-2.72307-.724849-1.32272-2.695926-1.6458-3.913848-.70843.306584.38076.444722.81633.54184 1.27676.505697-.67006 1.482812-.59037 1.939772-.18472.392034.34625.50133 1.15559.207266 1.7926-.228044.49392-.643964.7612-1.169685.84275-.925622.1436-1.420137-.60347-1.465014-1.38033-.01047-.77536-.07272-1.33376-.358246-1.78518-.196317-.3105-.514029-.59347-.839299-.76106-.704225-.36289-1.694519-.38931-2.378571.0362l.363024-1.86894-1.349175-.005z",
    id: "path2",
    style: {
      fill: "#ffffff"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFubo);
export default __webpack_public_path__ + "static/media/fubo.d404c44694b8c44e9137618fd6d05e0c.svg";
export { ForwardRef as ReactComponent };